import { apiClient } from '@/shared/api';
import { useAuthStore } from '@/shared/model';
import {
  telemetryPayloadSchema,
  type CreateTelemetryEvent,
  type ClientTelemetryEventName,
} from '@aegislab/shared';
import type { TelemetryPayload } from './types';

/**
 * 계측 이벤트 서버 적재 — page-view(trackPageView.ts)와 같은 규약.
 * userId 는 보내지 않는다. 서버가 쿠키 세션에서 뽑는다(위조 불가).
 */

/** 서버가 적재하는 키 — shared 스키마가 단일 소스라 여기서 다시 나열하지 않는다. */
const ALLOWED_PAYLOAD_KEYS = Object.keys(telemetryPayloadSchema.shape);

/**
 * 허용 목록에 없는 키를 떨군다.
 * 서버도 같은 스키마로 한 번 더 거르지만, 개인 식별 가능한 값은 네트워크에 올리는 것
 * 자체가 노출이라 브라우저를 떠나기 전에 자른다.
 */
function pickAllowed(payload: TelemetryPayload): CreateTelemetryEvent['payload'] {
  const picked: Record<string, string | number | boolean | null> = {};

  for (const key of ALLOWED_PAYLOAD_KEYS) {
    const value = payload[key];
    if (value !== undefined) picked[key] = value;
  }

  return picked;
}

/** fire-and-forget. 계측 실패가 화면을 깨뜨리면 안 된다. */
export function sendTelemetryEvent(
  name: ClientTelemetryEventName,
  payload: TelemetryPayload
): void {
  // 비로그인 사용자는 기록 대상이 아니다 (서버도 401 로 거절).
  if (useAuthStore.getState().user == null) return;

  void apiClient
    .post('/telemetry-events', {
      name,
      payload: pickAllowed(payload),
    } satisfies CreateTelemetryEvent)
    .catch(() => {
      // 계측 한 건은 버린다 — 화면이 이 실패를 알 이유가 없고, 운영 보고는 axios 인터셉터가 한다.
    });
}
